import {
    FETCH_RASPA_RECIPE_USAGE_STATISTICS,
    FETCH_RASPA_RECIPES,
    NEW_RASPA_RECIPE,
    NEW_RASPA_RECIPE_SUCCESS,
    RECEIVE_RASPA_RECIPE_USAGE_STATISTICS,
    RECEIVE_RASPA_RECIPES, RECEIVE_GLBRECEITAS, IS_FETCHING_GLBRECEITAS,
    IS_FETCHING_GLB_RECEITA_CATEGORIAS,
    RECEIVE_GLB_RECEITA_CATEGORIAS,
    PATCH_GLB_RECEITA_EHATIVO,
    PATCH_GLB_RECEITA_EHATIVO_SUCCESS,
    IS_FETCHING_GLB_PNEU_MODELOS,
    RECEIVE_GLB_PNEU_MODELOS,
    IS_FETCHING_GLB_PNEU_MEDIDAS,
    RECEIVE_GLB_PNEU_MEDIDAS,
    IS_FETCHING_GLB_BANDAS,
    RECEIVE_GLB_BANDAS
} from "../actions/actionTypes";

const initalState = {
    isFetchingRaspaRecipes: false,
    isFetchingRaspaCycleStatistics: false,
    isFetchingGlbReceitas: false,
    isFetchingGlbReceitaCategorias: false,
    isFetchingGlbPneuModelos: false,
    isFetchingGlbPneuMedidas: false,
    isFetchingGlbBandas: false,
    RaspaRecipes: [],
    RaspaRecipeStatistics: {
        countUsage: [],
        recipeUsage: [],
        sideCorrectionUsage: []
    },
    GlbReceitas: [],
    GlbReceitaCategorias: [],
    GlbPneuModelos: [],
    GlbPneuMedidas: [],
    GlbBandas: [],
}

export default (state = initalState, action) => {
    switch(action.type) {
        case IS_FETCHING_GLBRECEITAS:
            return {
                ...state,
                isFetchingGlbReceitas: true
            }

        case RECEIVE_GLBRECEITAS:
            return {
                ...state,
                isFetchingGlbReceitas: false,
                GlbReceitas: action.payload
            }

        case FETCH_RASPA_RECIPES:
            return {
                ...state,
                isFetchingRaspaRecipes: true
            }
        case RECEIVE_RASPA_RECIPES:
            return {
                ...state,
                isFetchingRaspaRecipes: false,
                RaspaRecipes: action.payload
            }
        case NEW_RASPA_RECIPE:
            return {
                ...state,
                isFetchingRaspaRecipes: true
            }
        case NEW_RASPA_RECIPE_SUCCESS:
            let newArray = state.RaspaRecipes;
            newArray.push(action.payload);
            return {
                ...state,
                isFetchingRaspaRecipes: false,
                RaspaRecipes: newArray
            }
        case FETCH_RASPA_RECIPE_USAGE_STATISTICS:
            return {
                ...state,
                isFetchingRaspaCycleStatistics: true,
                RaspaRecipeStatistics: action.payload
            }
            break;
        case RECEIVE_RASPA_RECIPE_USAGE_STATISTICS:
            return {
                ...state,
                isFetchingRaspaCycleStatistics: false,
                RaspaRecipeStatistics: action.payload
            }
            break;

        case IS_FETCHING_GLB_RECEITA_CATEGORIAS:
            return {
                ...state,
                isFetchingGlbReceitaCategorias: true
            }
        case RECEIVE_GLB_RECEITA_CATEGORIAS:
            return {
                ...state,
                isFetchingGlbReceitaCategorias: false,
                GlbReceitaCategorias: action.payload
            }

        case PATCH_GLB_RECEITA_EHATIVO:
            return {
                ...state,
                GlbReceitas: state.GlbReceitas.map(r =>
                    r.id === action.payload.id ? { ...r, ehAtivo: action.payload.ehAtivo } : r
                )
            }
        case PATCH_GLB_RECEITA_EHATIVO_SUCCESS:
            return {
                ...state,
                GlbReceitas: state.GlbReceitas.map(r =>
                    r.id === action.payload.id ? { ...r, ehAtivo: action.payload.ehAtivo } : r
                )
            }

        case IS_FETCHING_GLB_PNEU_MODELOS:
            return { ...state, isFetchingGlbPneuModelos: true }
        case RECEIVE_GLB_PNEU_MODELOS:
            return { ...state, isFetchingGlbPneuModelos: false, GlbPneuModelos: action.payload }

        case IS_FETCHING_GLB_PNEU_MEDIDAS:
            return { ...state, isFetchingGlbPneuMedidas: true }
        case RECEIVE_GLB_PNEU_MEDIDAS:
            return { ...state, isFetchingGlbPneuMedidas: false, GlbPneuMedidas: action.payload }

        case IS_FETCHING_GLB_BANDAS:
            return { ...state, isFetchingGlbBandas: true }
        case RECEIVE_GLB_BANDAS:
            return { ...state, isFetchingGlbBandas: false, GlbBandas: action.payload }

        default:
            return state;
    }
}
